import { AnalyticsDateParams, DashboardAnalyticsResponse, UserAnalyticsResponse, ProductAnalyticsResponse, OrderAnalyticsResponse, AuditAnalyticsResponse, ProductLifecycleAnalyticsResponse } from '@core/models/analytics.model';
import API from 'services/api';
import { fetchWithRetry } from 'services/fetchWithRetry';

class AnalyticsService {
    private readonly dashboardAnalyticsURL = `/api/analytics/dashboard`;
    private readonly userAnalyticsURL = `/api/analytics/users`;
    private readonly productAnalyticsURL = `/api/analytics/products`;
    private readonly orderAnalyticsURL = `/api/analytics/orders`;
    private readonly auditAnalyticsURL = `/api/analytics/audit`;
    private readonly productLifecycleAnalyticsURL = `/api/analytics/product-lifecycle`;
    // ---------------------------------------------------------------

    getDashboardAnalytics(params?: AnalyticsDateParams) {
        return fetchWithRetry(API.get<DashboardAnalyticsResponse>(this.dashboardAnalyticsURL, { params }));
    }

    getUserAnalytics(params?: AnalyticsDateParams) {
        return fetchWithRetry(API.get<UserAnalyticsResponse>(this.userAnalyticsURL, { params }));
    }

    getProductAnalytics() {
        return fetchWithRetry(API.get<ProductAnalyticsResponse>(this.productAnalyticsURL));
    }

    getOrderAnalytics(params?: AnalyticsDateParams) {
        return fetchWithRetry(API.get<OrderAnalyticsResponse>(this.orderAnalyticsURL, { params }));
    }

    getAuditAnalytics(params?: AnalyticsDateParams) {
        return fetchWithRetry(API.get<AuditAnalyticsResponse>(this.auditAnalyticsURL, { params }));
    }

    getProductLifecycleAnalytics(params?: AnalyticsDateParams) {
        return fetchWithRetry(API.get<ProductLifecycleAnalyticsResponse>(this.productLifecycleAnalyticsURL, { params }));
    }
}

export default new AnalyticsService();

